<div class="content-wrapper">
	<div class="content-body">
		<!-- content-header component -->
		<app-content-header [contentHeader]="contentHeader"></app-content-header>

		<!-- Basic Alerts start -->
		<section id="sample-page">
			<div class="row">
				<div id="stepper1" class="bs-stepper horizontal-wizard-example"></div>
				<div class="col-12">
					<div class="card">
						<div class="card-body pb-1">
							<form #cadastroForm="ngForm">
								<div class="card-body pb-1">

									<div class="col-md-6 col-12">
										<div class="form-group mb-2">
											<label>Tipo Perfil</label>
											<input [(ngModel)]="tipo" #tipoRef="ngModel" class="form-ngModel" required
												type="text" name="nome" class="form-control"
												[class.error]="!tipoRef.valid && cadastroForm.submitted"
												placeholder="Nome do perfil" />
											<span *ngIf="cadastroForm.submitted && tipoRef.invalid"
												class="invalid-form">
												<small class="form-text text-danger" *ngIf="tipoRef.errors.required">
													Campo Obrigatório!
												</small>
											</span>
										</div>
									</div>
									<br>
									<br>
									<div class="col-md-6 col-12">
										<div class="form-group mb-2">
											<h6>Telas permitidas:</h6>
											<br>
											<div class="custom-control custom-checkbox">
												<input type="checkbox" class="custom-control-input" id="customCheck1"
													checked />
												<label class="custom-control-label" for="customCheck1">Dashboard</label>
											</div>
											<br>
											<div class="custom-control custom-checkbox">
												<input type="checkbox" class="custom-control-input" id="customCheck2"
													checked />
												<label class="custom-control-label" for="customCheck2">Exemplo</label>
											</div>
											<br>
											<div class="custom-control custom-checkbox">
												<input type="checkbox" class="custom-control-input" id="customCheck3"
													checked />
												<label class="custom-control-label" for="customCheck3">Exemplo</label>
											</div>
											<br>
											<div class="custom-control custom-checkbox">
												<input type="checkbox" class="custom-control-input" id="customCheck4"
													checked />
												<label class="custom-control-label" for="customCheck4">Exemplo</label>
											</div>
											<br>
										</div>
									</div>

								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</div>